// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './mable-fees-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetMableFeesQueryVariables = GraphQLSchema.Exact<{
  agreementId?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['ID']['input']>;
}>;


export type GetMableFeesQuery = { __typename?: 'Query', mableFees?: { __typename?: 'MableFee', clientFeePercentage: number, workerFeePercentage: number } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class GetMableFeesQueryService extends Apollo.Query<GetMableFeesQuery, GetMableFeesQueryVariables> {
    document = Operations.GetMableFeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }